import { createFileRoute } from '@tanstack/react-router';
import { InventoryUploadPage } from '@/pages/InventoryUpload';

type Tab = 'vendor-management' | 'inventory-upload' | 'search-part-number';

const VALID_TABS: Tab[] = ['vendor-management', 'inventory-upload', 'search-part-number'];

export const Route = createFileRoute('/_admin/inventory-upload')({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: (VALID_TABS.includes(search.tab as Tab) ? search.tab : 'vendor-management') as Tab,
  }),
  component: InventoryUploadPage,
});
